const GLOBAL_LAYOUT_KEYS = [
  'landscape_variation',
  'brand_primary_color',
  'brand_accent_color',
  'visual_gradient_start_color',
  'visual_gradient_end_color',
  'visual_overlay_strength',
  'visual_text_position',
  'video_duration_seconds',
  'ken_burns_zoom',
  'ken_burns_direction',
];

const FORMAT_LAYOUT_KEYS = [
  'visual_headline_size_percent',
  'visual_headline_x_percent',
  'visual_headline_y_percent',
  'visual_cta_size_percent',
  'visual_cta_x_percent',
  'visual_cta_y_percent',
  'visual_headline_color',
  'visual_cta_color',
  'visual_logo_size_percent',
  'visual_partner_logo_x_percent',
  'visual_partner_logo_y_percent',
  'image_overlay_size_percent',
  'image_overlay_x_percent',
  'image_overlay_y_percent',
];

const PHONE_LAYOUT_KEYS = [
  'phone_frame_url',
  'phone_size_percent',
  'phone_x_percent',
  'phone_y_percent',
  'phone_tilt_degrees',
  'phone_screen_x_percent',
  'phone_screen_y_percent',
  'phone_screen_width_percent',
  'phone_screen_height_percent',
  'phone_screen_zoom_percent',
  'phone_screen_corner_radius_percent',
  'phone_screen_corners',
  'phone_overlay_text_size_percent',
  'phone_overlay_text_color',
  'phone_subheader_text_size_percent',
  'phone_subheader_text_color',
  'phone_overlay_logo_size_percent',
  'phone_partner_logo_padding_percent',
  'phone_background_start_color',
  'phone_background_end_color',
  'phone_partner_logo_position',
  'phone_guidesofia_logo_position',
  'phone_overlay_text_position',
  'phone_subheader_position',
  'phone_show_qr',
  'phone_qr_size_percent',
  'phone_qr_position',
];

const definedEntries = (source, keys) => keys.reduce((result, key) => {
  if (source?.[key] !== undefined && source?.[key] !== null && source?.[key] !== '') {
    result[key] = source[key];
  }
  return result;
}, {});

export const extractMediaPackageLayoutPreset = (config = {}) => ({
  global: definedEntries(config, GLOBAL_LAYOUT_KEYS),
  phone: definedEntries(config, PHONE_LAYOUT_KEYS),
  formats: Object.entries(config.asset_copy || {}).reduce((result, [formatId, formatConfig]) => {
    const layout = definedEntries(formatConfig, FORMAT_LAYOUT_KEYS);
    if (Object.keys(layout).length > 0) result[formatId] = layout;
    return result;
  }, {}),
});

export const applyMediaPackageLayoutPreset = (config = {}, preset = {}) => ({
  ...config,
  ...(preset.global || {}),
  ...(preset.phone || {}),
  asset_copy: Object.entries(preset.formats || {}).reduce((result, [formatId, layout]) => ({
    ...result,
    [formatId]: {
      ...(result[formatId] || {}),
      ...layout,
    },
  }), { ...(config.asset_copy || {}) }),
});

export const preserveMediaPackageFormatLayouts = (assetCopy = {}) => (
  Object.fromEntries(Object.entries(assetCopy).map(([id, copy]) => [id, {
    ...definedEntries(copy, FORMAT_LAYOUT_KEYS),
    ...definedEntries(copy, ['format_image_url', 'format_image_attribution']),
  }]))
);
